/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
import { Message, MessageBox, Loading } from 'element-ui'
import store from '../store'
import { getRegisterUrl, getToolUrl } from '@/utils/auth'
const DS = require('dsbridge')

export function getUrlName(name, url) {
  var r = new RegExp('(\\?|#|&)' + name + '=([^&#]*)(&|#|$)')
  var newUrl = url || location.href
  var m = newUrl.match(r)
  return decodeURIComponent(!m ? '' : m[2])
}

// 设置标题 meta
export function setTitle(obj) {
  document.title = obj.site_title || title
  if(obj.meta_keyword) {
    document.querySelector('meta[name="keyword"]')['content'] = obj.meta_keyword
  }
  if(obj.meta_desc) {
    document.querySelector('meta[name="description"]')['content'] = obj.meta_desc
  }
  if(obj.site_favicon) {
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = obj.site_favicon;
    document.getElementsByTagName('head')[0].appendChild(link)
  }
  
}
// 修改主题色
export function setCssVar (prop, val, dom = document.documentElement) {
  dom.style.setProperty(prop, val)
}
// 将十六进制转成rgb
export function  hexToRgb(hex) {
const r = parseInt(hex.substring(1, 3), 16);
const g = parseInt(hex.substring(3, 5), 16);
const b = parseInt(hex.substring(5, 7), 16);
return `${r}, ${g}, ${b}`;
}

// 设置原生头部样式
export function setHeader (params) {
  console.log(params)
  DS.call('DS.setHeader', {
      native_headershow: params.showHeader, // 1 显示原生titlebar，其他不显示
      statusBarAppearance: params.statusBarAppearance, // 1 状态栏沉浸式 
      titleName: params.titleName, // 标题栏的名字
      top_link_image: params.top_link_image, // 图片背景链接
      topstyle: params.topstyle, // topimg 图片 topcolor 颜色背景
      native_top_words_color: params.native_top_words_color, // 文字颜色
      str_link_color: params.str_link_color, // 颜色背景渐变色开始色
      end_link_color: params.end_link_color, // 颜色背景渐变色结束色
      isBounceEnabled: params.bounceEnabled, // ios 页面弹动 1 可弹动 0 禁止弹动
      isHideCloseBt:  params.hideCloseBtn    //是否隐藏关闭按钮 0，不隐藏，1隐藏
  })
}
